let express = 1000 * 60 * 60 * 48 //设置过期时间   1000*60(一分钟)    1000*60*60(一小时) 
export const mystorage = {
  set(key, data, time) {
    let obj = {
      data: data,
      ctime: Date.now(),
      express: express
    }
    sessionStorage.setItem(key, JSON.stringify(obj))
  },
  get(key) {
    const raw = sessionStorage.getItem(key);
    if (raw === null) return '';
    let obj;
    try {
      obj = JSON.parse(raw);
    } catch (e) {
      return '';
    }
    if (!obj) return '';
    const now = Date.now();
    if (now - obj.ctime >= express) {
      // 已过期，清除并返回空
      sessionStorage.removeItem(key);
      return '';
    } else {
      // 未过期，自动续期
      obj.ctime = now;
      sessionStorage.setItem(key, JSON.stringify(obj));
      return obj.data;
    }
  },
  remove(key) {
    sessionStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// ./src/utils/myStorage.js